import React from "react";
import KickImage from 'Reuseables/KickImage';
import axios from 'axios';
import {
  SHIPPER_KEY,
  PROMISE_PENDING,
  PROMISE_REJECTED,
  PROMISE_FULFILLED,
  SHIPPER_BASE_URL,
  SHIPPER_LOCATION,
  SHIPPER_DOWNLOAD_STICKER_URL,
  SHIPPER_DOWNLOAD_RECEIPT_URL,
  AUTH_TOKEN_KEY,
  API_BASE_URL
} from '../constants/';

import { noReduxApi } from "../utils/Api"

import store from "../store";

const shipperAPI = (headers = {}) => {
  const instance = axios.create({
    baseURL: SHIPPER_BASE_URL,
    headers: {
      'X-API-Key': SHIPPER_KEY,
      'x-kickavenue-platform': 'web',
      'Access-Control-Allow-Origin': '*',
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  })

  instance.interceptors.response.use(
    response => {
      // Do something with response 
      return response;
    },
    (error) => {
      // Do something with response error
      return Promise.reject(error);
    }
  )

  return instance;
}

const ADM_LEVEL = {
  country: 1,
  province: 2,
  city: 3,
  suburb: 4,
  area: 5
}
const TOKEN = () => ({ Authorization: "Bearer " + localStorage.getItem(AUTH_TOKEN_KEY) })

export const getShipper = (url) => {
  return noReduxApi(TOKEN()).get(`/users/shipper/location/${url}`)
};

export const getAreaId = (area_id) => {
  return noReduxApi(TOKEN()).get(`/users/shipper/location/area/${area_id}`)
};

export const getReceipt = (order_id) => {
  return noReduxApi(TOKEN()).get(`/users/shipper/shipping-receipt/${order_id}`)
}

export const getSticker = (order_id, label_check_sum) => {
  return noReduxApi(TOKEN()).get(`/users/shipper/shipping-label/${order_id}`)
}

export const submitAddShippingAddress = (payload) => {
  return noReduxApi(TOKEN()).post(`/users/seller-shipping`, payload)
};

export const submitUpdateShippingAddress = (payload, id) => {
  return noReduxApi(TOKEN()).put(`/users/seller-shipping/${id}`, payload)
};

export const updateDefaultAddress = (id) => {
  return noReduxApi(TOKEN()).put(`/users/seller-shipping/${id}/set_default`)
};

export const deleteAddress = (id) => {
  return noReduxApi(TOKEN()).delete(`/users/seller-shipping/${id}`)
};

export const getPricingList = (payload) => {
  return noReduxApi(TOKEN()).post(`/users/shipper/pricing`, payload)
};

export const getListAddress = () => {
  return noReduxApi(TOKEN()).get(`/users/seller-shipping`)
};

export const createOrder = (payload) => {
  return noReduxApi(TOKEN()).post(`/users/shipper/order`, payload)
};

export const getOrderDetails = (order_id) => {
  return noReduxApi(TOKEN()).get(`/users/shipper/order/${order_id}`)
};

export const getPickupTimeSlot = (time_zone) => {
  return noReduxApi(TOKEN()).post(`/users/shipper/pickup/timeslot`, { time_zone })
};

export const createPickupRequest = (payload) => {
  return noReduxApi(TOKEN()).post(`/users/shipper/pickup`, payload)
};

export const cancelPickupRequest = (order_id, payload) => {
  return noReduxApi(TOKEN()).delete(`/users/shipper/order/${order_id}`, { data: payload })
};

export const fetchCourierNoRedux = () => {
  return noReduxApi().get(`/couriers`)
}

export const submitDropoff = (payload, sale_id) => {
  return noReduxApi(TOKEN()).post(`/users/orders/${sale_id}/awb-number`, payload)
}

export const submitDropoffConsignments = (payload, sale_id) => {
  return noReduxApi(TOKEN()).post(`/users/consignments/${sale_id}/awb-number`, payload)
}

export const getDropoffScheduledSetting = () => {
  return noReduxApi(TOKEN()).get(`settings?keyword=dropoff_time_availability`)
}

export const getTrackingShipper = (order_id) => {
  return noReduxApi(TOKEN()).get(`users/shipper/tracking/${order_id}`)
}

